__turbopack_context__.v({
  "availabilityMessageContainer": "StoreAvailabilityMessage-module-scss-module__DjJsmG__availabilityMessageContainer",
  "availabilityText": "StoreAvailabilityMessage-module-scss-module__DjJsmG__availabilityText",
  "availabilityTextInline": "StoreAvailabilityMessage-module-scss-module__DjJsmG__availabilityTextInline",
  "linkPunctuation": "StoreAvailabilityMessage-module-scss-module__DjJsmG__linkPunctuation",
  "secondLine": "StoreAvailabilityMessage-module-scss-module__DjJsmG__secondLine",
  "storeNameButton": "StoreAvailabilityMessage-module-scss-module__DjJsmG__storeNameButton",
});
